import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "gfu-grid gfu-grid--gutter-columns _mt-4" }
const _hoisted_2 = {
  class: "gfu-grid__cell gfu-1of1",
  "data-qa": "shipping-method-section"
}
const _hoisted_3 = { class: "gfu-heading gfu-heading--top-divider" }
const _hoisted_4 = ["data-qa"]
const _hoisted_5 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_notificator = _resolveComponent("base-notificator")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("fieldset", null, [
        _createElementVNode("h2", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.Resources.Checkout.ShippingMethodSectionTitle), 1 /* TEXT */),
          _cache[1] || (_cache[1] = _createElementVNode("em", null, "*", -1 /* CACHED */))
        ]),
        ($options.showNotAllShippingFeesIncludedNotification)
          ? (_openBlock(), _createBlock(_component_base_notificator, {
              key: 0,
              type: "info",
              "can-close": false,
              message: $options.notAllShippingFeesIncludedNotificationMessage,
              class: "_mt-2",
              "data-qa": "notificator-item-info:NotAllShippingFeesIncluded"
            }, null, 8 /* PROPS */, ["message"]))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_field, {
          class: "_mt-0",
          "base-class": "",
          name: "shippingModelID",
          "show-label": false
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.mappedShippingModels, (shippingModel) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `shipping-method-${shippingModel.shippingModelID}`,
                "data-qa": 'begin-order-form-shipping-method:'+ shippingModel.shippingModelID
              }, [
                _createVNode(_component_checkbox_field, {
                  modelValue: $options.shippingModelID,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.shippingModelID) = $event)),
                  "checked-value": shippingModel.shippingModelID,
                  condensed: true,
                  type: "radio"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(shippingModel.name) + " ", 1 /* TEXT */),
                    (shippingModel.shippingCostDifferenceConverted !== null)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          "data-qa": `shipping-cost:${shippingModel.shippingCostDifferenceConverted}`
                        }, _toDisplayString(shippingModel.shippingInfo), 9 /* TEXT, PROPS */, _hoisted_5))
                      : _createCommentVNode("v-if", true),
                    (shippingModel.description)
                      ? (_openBlock(), _createBlock(_component_tooltip, {
                          key: 1,
                          text: shippingModel.description
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("em", null, [
                              _createVNode(_component_base_icon, { name: "circle-info" })
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["text"]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "checked-value"])
              ], 8 /* PROPS */, _hoisted_4))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _renderSlot(_ctx.$slots, "actions")
    ])
  ]))
}